export default __webpack_public_path__ + "static/media/greenTheme-girl.95973dba.svg";